export default "__VITE_ASSET__Cz7L1HP1__"